var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Banner",class:{
    'NoGradient': _vm.noGradient,
    'MenuBanner': _vm.forMenu
  },style:({
    'background-image': _vm.src ? ("url(" + _vm.src + ")") : '',
    'min-height': _vm.src ? (_vm.minHeight + "px") : ''
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }